import React, { useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Container,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Divider,
  Menu,
  MenuItem,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import { Link, useLocation } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import logo from "../assets/sava_logo.PNG";
import tanzaniaflag from "../assets/tanzaniaflag.png";

const Navbar = ({ activeLink, setActiveLink }) => {
  const location = useLocation();
  const theme = useTheme();

  // Update activeLink state when the route changes
  useEffect(() => {
    setActiveLink(location.pathname); // Automatically update the active link based on the route
  }, [location.pathname, setActiveLink]);

  const links = [
    { label: "Home", to: "/home" },
    { label: "Ambassador", to: "/ambassador" },
    { label: "Contact", to: "/contact" },
    { label: "Careers", to: "/careers" },
    { label: "FAQ", to: "/faq" },
  ];

  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [flag,setSelectedFlag] = React.useState(null)

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  const handleFlagClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleFlagSelect = (flag) => {
    setSelectedFlag(flag);
    setAnchorEl(null);
  };

  return (
    <>
      <AppBar position="sticky" sx={{ backgroundColor: theme.palette.background.paper, boxShadow: 0 }}>
        <Box sx={{ backgroundColor: theme.palette.primary.main }}>
          <Container maxWidth="lg" sx={{ maxWidth: "1300px", width: "100%" }}>
            <Box sx={{ display: { xs: "none", md: "flex" }, justifyContent: "space-between", alignItems: "center", paddingY: "0px" }}>
              <Box sx={{ display: "flex" }}>
                <IconButton>
                  <a
                    href="https://www.linkedin.com/company/sava-tech-tz/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <LinkedInIcon sx={{ color: "white" }} />
                  </a>
                </IconButton>
                <IconButton sx={{ color: "white" }}>
                  <a
                    href="https://www.instagram.com/sava_loan?igsh=cTFjNHh0aDhteGVs"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <InstagramIcon />
                  </a>
                </IconButton>
                <IconButton sx={{ color: "white" }}>
                  <a
                    href="https://www.facebook.com/share/193aYRi3Vt/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <FacebookIcon />
                  </a>
                </IconButton>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography variant="body2" sx={{ marginLeft: "10px", color: "white" }}>
                  info@sava.co.tz | +255 672 600 151
                </Typography>
                <IconButton onClick={handleFlagClick}>
                  <img alt="tan" src={tanzaniaflag} style={{ height: "20px", width: "20px", borderRadius: "20px" }} />
                </IconButton>

                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={() => setAnchorEl(null)}
                  PaperProps={{
                    sx: {
                      backgroundColor: theme.palette.secondary.main,
                    },
                  }}
                >
                  <MenuItem onClick={() => handleFlagSelect("TZ")} sx={{ color: "black", height: "20px" }}>
                    Swahili
                  </MenuItem>
                  <Divider sx={{ backgroundColor: "black" }} />
                  <MenuItem onClick={() => handleFlagSelect("UK")} sx={{ color: "black", height: "20px" }}>
                    English
                  </MenuItem>
                </Menu>
              </Box>
            </Box>
          </Container>
        </Box>

        <Container maxWidth="lg" sx={{ maxWidth: "1300px" }}>
          <Toolbar disableGutters>
            <Link to="/home" style={{ display: "flex", alignItems: "center", textDecoration: "none" }}>
              <img alt="logo" src={logo} style={{ height: "35px", width: "35px" }} />
              <Typography variant="h4" sx={{ flexGrow: 1, color: "black", fontWeight: 700 }}>
                SAVA
              </Typography>
            </Link>
            <Box sx={{ flexGrow: 1 }} />

            <IconButton size="large" edge="end" color="inherit" sx={{ display: { xs: "block", md: "none" } }} onClick={toggleDrawer(true)}>
              <MenuIcon sx={{ color: "black" }} />
            </IconButton>

            <Box sx={{ display: { xs: "none", md: "flex" }, marginLeft: "auto" }}>
              {links.map((link, index) => (
                <Box key={index} sx={{ position: "relative", margin: "0 15px" }}>
                  <Link
                    to={link.to}
                    onClick={() => setActiveLink(link.to)} // Update active link on click
                    style={{ textDecoration: "none", color: "black", cursor: "pointer" }}
                  >
                    <Typography variant="body1" sx={{ fontWeight: 450 }}>
                      {link.label}
                    </Typography>
                  </Link>
                  {activeLink === link.to && location.pathname !== "/" && (
                    <Box
                      sx={{
                        height: "2px",
                        width: "100%",
                        backgroundColor: "black",
                        position: "absolute",
                        bottom: "-5px",
                        left: 0,
                      }}
                    />
                  )}
                </Box>
              ))}
            </Box>

            <Drawer anchor="top" open={drawerOpen} onClose={toggleDrawer(false)}>
              <Box
                sx={{
                  padding: "1px",
                  height: "60px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  backgroundColor: theme.palette.background.paper,
                  boxShadow: 0,
                }}
              >
                <Link
                  onClick={toggleDrawer(false)}
                  to="/home"
                  style={{ display: "flex", alignItems: "center", textDecoration: "none" }}
                >
                  <img alt="logo" src={logo} style={{ height: "25px", width: "25px", paddingLeft: 10 }} />
                  <Typography variant="h6" sx={{ flexGrow: 1, color: "black" }}>
                    SAVA
                  </Typography>
                </Link>

                <IconButton onClick={toggleDrawer(false)}>
                  <CloseIcon />
                </IconButton>
              </Box>
              <Divider />

              <List sx={{ width: "100%", backgroundColor: "white" }}>
                {links.map((link, index) => (
                  <ListItem button key={index} onClick={toggleDrawer(false)}>
                    <Link
                      to={link.to}
                      style={{
                        textDecoration: "none",
                        color: "black",
                        width: "100%",
                        padding: "0px 1px",
                      }}
                    >
                      <ListItemText primary={link.label}
                      sx={{
                        "&:after": activeLink === link.to
                ? {
                    content: '""',
                    position: "absolute",
                    bottom: 15, // Adjust to place the line just below the text
                    left: 0,
                    width: "7%",
                    marginLeft:'16px',
                    
                    height: "2px", // The height of the line
                    backgroundColor: "black", // Black underline color
                  }
                : undefined,
                      }}
                       />
                    </Link>
                  </ListItem>
                ))}
              </List>
            </Drawer>
          </Toolbar>
        </Container>
      </AppBar>
    </>
  );
};

export default Navbar;
